export type ChangeEventPayload = {
  value: string;
};

export type NekoTestViewProps = {
  name: string;
};
